import { infoApi } from '@shared/info-api-config';
import { documentsAndRequests } from '@shared/documents-and-requests-config';
import _ from '@luna/lodash';
import { appointments } from '@retail/appointments-config';
import { contactDataManagement } from '@shared/contact-data-management-config';
import { kyc } from '@retail/kyc-config';
import { messenger } from '@shared/messenger-config';
import { gdpr } from '@retail/profile-administration-config';
import { cards } from '@retail/cards-config';
import { overview } from '@retail/overview-config';
import {
    AccountsCurrentFeatureConfig,
    AccountsFeatureConfig,
    BuildingSocietyFeatureConfig,
    ProductsFeatureConfig,
    SavingsFeatureConfig,
    StatementFeatureConfig,
} from '@retail/products-config';
import { exportFeatures, transactions } from '@retail/transactions-config';
import { navigation } from '@retail/navigation-config';
import { supportChatFeatureConfigMap } from '@shared/support-chat-config';
import { securitySettings } from '@shared/security-settings-config';

import { arrayOverwrite, baseFeatureConfig, extendFeatureConfigFromUrl } from './base';
import type { PartialRetailFeatureConfig } from './featureConfig';

export const countryFeatures: PartialRetailFeatureConfig = {
    appointments: appointments.HR,
    contactDataManagement: contactDataManagement.HR,
    documentsAndRequests: documentsAndRequests.HR,
    kyc: kyc.HR,
    messenger: messenger.HR,
    gdpr: gdpr.HR,
    cards: cards.HR,
    overview: overview.HR,
    statements: StatementFeatureConfig.HR,
    transactions: transactions.HR,
    export: exportFeatures.HR,
    savings: SavingsFeatureConfig.HR,
    supportChat: supportChatFeatureConfigMap.HR,
    securitySettings: securitySettings.HR,
    base: {
        country: 'HR',
        newAccountModel: true,
        ibanCountryCode: 'HR',
        defaultLanguage: 'hr',
        allowedLanguages: ['en', 'hr', 'de'],
        availableLanguages: ['en', 'hr', 'de', 'de-NA', 'en-CK'],
        defaultCurrency: 'EUR',
        defaultCurrencySign: '€',
        loanProductAmount: 'balance',
        defaultCurrencyPre: false,
        thousandSeparator: ' ',
        sendLanguageHeader: true,
        aliasValidationStringWithoutGlobal:
            /[0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz áßäčďéěíĺľňóöôřŕšťúůüýžćĆđĐŽŠČÁÄĎÉĚÍĹĽŇÓÖÔŘŔŤÚŮÜÝ,.;:!?@&+\-*/()_#]/i.toString(),
        useVersionHeaders: false,
        latestVersionHeader: null,
        doPreCurrencyCheck: false,
        defaultTimezone: 'Europe/Zagreb',
        languageOverrides: {
            de: 'de-NA',
            en: 'en-CK',
        },
    },
    footer: {
        links: {
            fx: {
                hr: 'https://www.erstebank.hr/hr/alati',
                de: 'https://www.erstebank.hr/hr/alati',
                en: 'https://www.erstebank.hr/hr/alati',
            },
            imprint: {
                hr: 'https://www.erstebank.hr/hr/karijere/o-nama',
                de: 'https://www.erstebank.hr/hr/karijere/o-nama',
                en: 'https://www.erstebank.hr/hr/karijere/o-nama',
            },
            privacy: {
                hr: 'https://www.erstebank.hr/hr/zastita-privatnosti',
                de: 'https://www.erstebank.hr/hr/zastita-privatnosti',
                en: 'https://www.erstebank.hr/hr/zastita-privatnosti',
            },
            termsAndConditions: {
                hr: 'https://www.erstebank.hr/hr/opci-uvjeti-i-metodologija',
                de: 'https://www.erstebank.hr/hr/opci-uvjeti-i-metodologija',
                en: 'https://www.erstebank.hr/hr/opci-uvjeti-i-metodologija',
            },
        },
    },
    accounts: AccountsFeatureConfig.HR,
    navigation: navigation.HR,
    handover: {
        handoverTokenExchange: true,
    },
    settings: {
        changePassword: false,
    },
    currentAccount: AccountsCurrentFeatureConfig.HR,
    buildingSociety: BuildingSocietyFeatureConfig.HR,
    pfm: {
        changeCategory: false,
    },
    infoApi: infoApi.HR,
    devTools: {
        availableEnvironments: {
            Local: 'http://localhost:8080',
            Dev: 'https://hr.dev.beeone.at',
            FAT: 'https://georgefat.erstebank.hr',
            UAT: 'https://georgeuat.erstebank.hr',
            'UAT 2': 'https://georgeuat2.erstebank.hr',
            'UAT 3': 'https://georgeppr.erstebank.hr',
        },
    },
    tracking: {
        appId: 'INT92',
        appName: 'GeorgeWeb_Retail_HR',
        instituteId: 796,
    },
    products: ProductsFeatureConfig.HR,
    allowedRedirectDomains: ['erstebank.hr'],
};

const featureConfigWithBase = _.merge({}, baseFeatureConfig, countryFeatures, arrayOverwrite);
export const featureConfig = extendFeatureConfigFromUrl(featureConfigWithBase);
